<template>
  <div class="ProjectViewSummary">
    <eb-panel>
      <eb-panel-header class="panel-header" slot="header">
        <span slot="title">项目概述</span>
      </eb-panel-header>
      <div slot="body">
        <div class="panel-body-row">
          <div class="panel-body-row-left">项目编号</div>
          <div class="panel-body-row-right">{{project?project.projectCode:'-'}}</div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left">项目名称</div>
          <div class="panel-body-row-right">{{project?project.projectName:'-'}}</div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left projectInfo">项目简介</div>
          <div class="panel-body-row-right">
            <pre>{{project?project.projectInfo:'-'}}</pre>
          </div>
        </div>
      </div>
    </eb-panel>
  </div>
</template>
<script>
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
export default {
  name: 'ProjectViewSummary',
  props: {
    project: {
      required: true
    }
  },
  components: {
    ebPanel,
    ebPanelHeader
  }
};
</script>
<style lang="less" scoped>
.projectInfo {
  align-items: flex-start!important;
  padding-top:8px;
}
</style>
